import React, { useEffect } from 'react';

import { CloudProviders } from '@ariksa/cloud-account';
import { useDispatch } from 'react-redux';
import { useParams } from 'react-router-dom';

import { actions } from 'containers/Setup/CloudAccounts/slice';

import { EnableDataAccessManagementForAWS } from './EnableDataAccessManagementForAWS';
import { EnableDataAccessManagementForSnowflake } from './EnableDataAccessManagementForSnowflake';

export const EnableDataAccessManagement = () => {
  const dispatch = useDispatch();
  const params = useParams<{ id: string; provider: string }>();

  useEffect(() => {
    if (!!params.id) {
      dispatch(
        actions.loadCloudAccountDetails({
          q: {
            uuid: params.id,
          },
        }),
      );
    }
  }, [dispatch, params]);

  return params.provider === CloudProviders.Snowflake ? (
    <EnableDataAccessManagementForSnowflake />
  ) : (
    <EnableDataAccessManagementForAWS />
  );
};
